export default "__VITE_ASSET__CZchdE37__"